module.exports = __webpack_public_path__ + "img/haze.ff55b9b.dc7feff7.png";